module.exports = __webpack_public_path__ + "img/logo.db0f384d.png";